var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('p',{staticClass:"mb-0"},[_vm._v("Комментарий:")]),_vm._v(" "),_c('b-form-textarea',{attrs:{"id":"comment-textarea","placeholder":"Добавьте комментарий...","rows":"6"},model:{value:(_vm._commentText),callback:function ($$v) {_vm._commentText=$$v},expression:"_commentText"}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a63ea8a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CallComment.vue
// module id = 652
// module chunks = 0